// Import the CSS for the spinner
import './LoadingSpinnerAnimation.css';



// Export the LoadingSpinner component
export const LoadingSpinner = ({message}) => {

    // Return the spinner container and spinner element
    return (

        // The spinner wrapper
        <div className="loading-spinner__container">

            {/* The spinning circle */}
            <div className="loading-spinner__spinner"></div>

            {message &&

                <p>{message}</p>
            
            }

        </div>

    );

};
